import axios from 'axios';
import index from './index';
export default {
  getGalleries() {
    return axios.get(`/modules/${index.api}/`);
  },
};
